module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_Black.95a4b7e4.jpg";